import { create } from 'zustand';

/** What the home page shows: the library, the analysis progress, or the player. */
export type HomeScreen = 'library' | 'import' | 'player';

interface ScreenState {
  screen: HomeScreen;
  /** The song in the player (kept while the library is shown, so the player can come back). */
  songId: string | null;
  showLibrary: () => void;
  showImport: () => void;
  showPlayer: (songId: string) => void;
}

/**
 * The app is one page (ADR 0007): songs aren't saved, so an address per song couldn't be
 * reopened after a reload. Library, analysis and player swap in place on "/"; Settings and the
 * tuner are separate pages, and coming back returns to the same screen.
 */
export const useScreenStore = create<ScreenState>()((set) => ({
  screen: 'library',
  songId: null,
  showLibrary: () => {
    set({ screen: 'library' });
  },
  showImport: () => {
    set({ screen: 'import' });
  },
  showPlayer: (songId) => {
    set({ screen: 'player', songId });
  },
}));
